// let atlasPath = "/ATLAS/General/";
// Pruebas bug 1810
let atlasPath = "/ATLAS/General";
let listadoParametros = "/LISTAPARAMETROS/ListadoParametros";
let vistaInstanciaParametro = "/LISTAPARAMETROS/VistaInstanciaParametro";
let nuevaInstanciaParametro = "/LISTAPARAMETROS/NuevaInstanciaParametro"


let ProcessManager = function () {
    function _getNextStep(componenteActual, accion) {
        switch (componenteActual) {
            //switcheo por pantalla actual.
            case "ListadoParametros":
                //switcheo por accion desde esa pantalla.
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_LISTADO_PARAMETROS":
                        // return (atlasPath + "LISTAPARAMETROS/ListadoParametros");
                        return (atlasPath + listadoParametros);
                }
            case "VistaInstanciaParametro":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_VISTA_INSTANCIA_PARAMETRO":
                        // return (atlasPath + "LISTAPARAMETROS/VistaInstanciaParametro");
                        return (atlasPath + vistaInstanciaParametro);

                }
            case "NuevaInstanciaParametro":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_NUEVA_INSTANCIA_PARAMETRO":
                        // return (atlasPath + "LISTAPARAMETROS/NuevaInstanciaParametro");
                        return (atlasPath + nuevaInstanciaParametro);
                    case "ROUTE_TO_VISTA_INSTANCIA_PARAMETRO":
                        // return (atlasPath + "LISTAPARAMETROS/VistaInstanciaParametro");
                        return (atlasPath + vistaInstanciaParametro);
                }
            default:
                return atlasPath;
        }
    }

    //Funciones públicas
    return {
        GetNextStep: function (componenteActual, accion, params) {
            return _getNextStep(componenteActual, accion, params);
        }
    }
}

let processManager = new ProcessManager();
export default processManager;


// WEBPACK FOOTER //
// ./Portico/Productos/Atlas/App/Common/Managers/ProcessManager.js